/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from "react";
import Footer from "../../Layout/Footer";
import Home1 from "./Home1";
import Header2 from "../../Layout/Header";
import { useLocation } from "react-router-dom";

const Home = () => {
  const location = useLocation();
  // TODO: Remove this line
  let user = localStorage.getItem('user')
  user = user ? JSON.parse(user) : null

  function ToHome() {
    if (user && location.pathname !== '/home') {
      window.location = '/home'
    }

  }

  useEffect(() => {
    ToHome()
  }, [user])

  return (
    <>
      <Header2 />
      <Home1 />
      <Footer />
    </>
  );
};

export default Home

